module.exports = __webpack_public_path__ + "img/jinglirun.7b513995.png";